// Mirrors backend App\Enums\Payment\PaymentMethodType

export type PaymentMethodType =
  'credit_card' | 'debit_card' | 'paypal' | 'apple_pay' | 'google_pay' | 'cash'

export const PaymentMethodType = {
  CREDIT_CARD: 'credit_card',
  DEBIT_CARD: 'debit_card',
  PAYPAL: 'paypal',
  APPLE_PAY: 'apple_pay',
  GOOGLE_PAY: 'google_pay',
  CASH: 'cash'
} satisfies Record<string, PaymentMethodType>

export const PaymentMethodTypeValues: readonly PaymentMethodType[] =
  Object.values(PaymentMethodType)
